module.exports = __webpack_public_path__ + "img/10-5.a1a55b76.png";